import React from 'react';
import PropTypes from 'prop-types';
import AutoScopeStyles from '../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import DragDropFileBrowser from '../../../../Common/Components/DragDropFileBrowser.jsx';
import DisableOnActionInProgress from '../../../../Common/Components/DisableOnActionInProgress.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../../Utilities/Decorators/ApplyDecorators';

class CsvImportFileSelector extends React.Component {
    render() {
        return (
            <li>
                <form>
                    <h3>2. Choose a CSV file to import</h3>
                    <DragDropFileBrowser accept={['.csv', 'text/csv']} onFileChange={ this.uploadChosen } file={ this.props.file } />
                    <h3>3. Import { this.props.nameOfObjectToImport }</h3>
                    <p>Select the Import button to import your { this.props.nameOfObjectToImport }.</p>
                    <div className="right aligned container">
                        <DisableOnActionInProgress>
                            <button type="button" className="primary button" onClick={ this.sendButtonClicked } disabled={ !this.props.file }>Import</button>
                        </DisableOnActionInProgress>
                    </div>
                </form>
            </li>
            );
    }

    uploadChosen = (file) => {
        this.props.onFileSelected(file);
    }

    sendButtonClicked = () => {
        this.props.onUploadRequested();
    }

    static propTypes = {
        file: PropTypes.object,
        onUploadRequested: PropTypes.func.isRequired,
        onFileSelected: PropTypes.func.isRequired,
        nameOfObjectToImport: PropTypes.string.isRequired
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(CsvImportFileSelector);
